export const getRouteDisabled = (routeId: string) => {
  const disabledRoutes = import.meta.env.REACT_APP_DISABLED_ROUTES?.split('.')
  return disabledRoutes.includes(routeId)
}

export default getRouteDisabled
